export default function removeNumberAndSpecial(text = '') {
  const textWithoutNumber = text.replace(/[0-9]/g, '');
  // console.log(
  //   'removeNumberAndSpecial | textWithoutNumber: ',
  //   textWithoutNumber,
  // );

  return textWithoutNumber;
}
